import { type DocumentNode, gql } from '@apollo/client';

const getVersion: DocumentNode = gql`
  query version {
    version
  }
`;

export default getVersion;
